import { useId } from "react";
import { useTranslation } from "react-i18next";
import { MenuItem, TextField } from "@mui/material";
import { NO_TOPIC } from "../boardAdapter";

// Wert „Alle“ im Select; nach außen ist er null (Vertrag 6.4, 16.2).
const ALL = "";

/** Topic als reiner Filter: „Alle“ (null), „ohne Topic“ (NO_TOPIC) und je Topic; archivierte gekennzeichnet. */
export default function TopicFilter({ topics = [], value = null, onChange }) {
  const { t } = useTranslation("freigabe");
  const id = useId();
  const current = value === null || value === undefined ? ALL : value;
  // MUI-Menü im Portal nutzt dieselben Produktfarben wie die übrigen Auswahlfelder.
  return <TextField select size="small" id={id} label={t("stageBranches.topicFilter.label")} value={current}
    className="sb-topic-filter" SelectProps={{ displayEmpty: true, MenuProps: { PaperProps: { className: "iio iio-monitor-menu" } } }}
    InputLabelProps={{ shrink: true }} sx={{ minWidth: 200, maxWidth: "100%" }}
    onChange={event => onChange?.(event.target.value === ALL ? null : event.target.value)}>
    <MenuItem value={ALL}>{t("stageBranches.topicFilter.all")}</MenuItem>
    <MenuItem value={NO_TOPIC}>{t("stageBranches.topicFilter.none")}</MenuItem>
    {topics.map(topic => <MenuItem key={topic.id} value={topic.id}>
      {topic.archived ? t("stageBranches.topicFilter.archived", { name: topic.name }) : topic.name}
    </MenuItem>)}
  </TextField>;
}
